import { TableConfigMap } from './table-config.model';
import { TableHeader } from './table-config.model';
import { Plantilla } from './Plantilla.model';
import { Lote } from './Lote.model';
import { SignatureSize } from './SignatureSize.model';



export function formatFechaLocalSinUTC(iso?: string): string {

    if (!iso) {
        return '';
    }

    const limpia = iso.replace('Z', '').split('.')[0];

    const d = new Date(limpia);

    const pad = (n: number) => n.toString().padStart(2, '0');

    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} `
        + `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export interface TableConfig<T = any> {
    headers: TableHeader[];
    mapper: (item: T) => any;
}

export const TABLE_CONFIG: TableConfigMap = {

    Lote: {
        headers: [
            //{ key: 'id', label: 'ID' },
            { key: 'titulo', label: 'Titulo' },
            { key: 'notificacion_firmantes', label: 'Notificar Firmantes' },
            { key: 'es_grupo', label: 'Es Grupo' },
            { key: 'fecha_creacion', label: 'Fecha Creación' },
            { key: 'estado', label: 'Estado Lote' }
        ],

        mapper: (x) => ({
            id: x.id,
            titulo: x.titulo,
            notificacion_firmantes: x.notificacion_firmantes ? 'Si' : 'No',
            es_grupo: x.es_grupo ? 'Si' : 'No',
            estado: x.estado.nombre,
            id_estado: x.estado.id,
            firma_simple: x.firma_simple,
            fecha_creacion: formatFechaLocalSinUTC(x.createdAt)
        })
    },

    Plantilla: {
        headers: [
            { key: 'nombre', label: 'Nombre' },
            { key: 'fecha_creacion', label: 'Fecha Creación' },
            { key: 'tipo_acceso', label: 'Tipo Acceso' },
            { key: 'estado', label: 'Estado' },
        ],

        mapper: (x) => ({
            id: x.id,
            publica: x.publica,
            tipo_acceso: x.publica ? 'Pública' : 'Personalizado',
            nombre: x.nombre,
            estado: x.deletedAt === null ? 'Activo' : 'Inactivo',
            deletedAt: x.deletedAt,
            fecha_creacion: formatFechaLocalSinUTC(x.createdAt) // aquí hay un detalle
        })
    },

    Grupo: {
        headers: [
            { key: 'nombre', label: 'Nombre' },
            { key: 'tipoGrupo', label: 'Grupo' },
            { key: 'tipo_acceso', label: 'Tipo Acceso' },
        ],

        mapper: (x) => ({
            id: x.id,
            nombre: x.nombre,
            tipoGrupo: x.tipoGrupo,
            tipo_acceso: x.publica ? 'Pública' : 'Personalizado',
        })
    },

    SignatureSize: {
        headers: [
            { key: 'nombre', label: 'Nombre' },
            { key: 'nombre_corto', label: 'Nombre Corto' },
            { key: 'width', label: 'Ancho' },
            { key: 'height', label: 'Alto' },
            { key: 'createdAt', label: 'Fecha Creación' },
            { key: 'updatedAt', label: 'Fecha Actualización' }
        ],

        mapper: (x) => ({
            id: x.id,
            nombre: x.nombre,
            nombre_corto: x.nombre_corto,
            // nombre_corto: x.publica ? 'Pública' : 'Personalizado',
            width: x.width,
            height: x.height,
            createdAt: formatFechaLocalSinUTC(x.createdAt),
            updatedAt: formatFechaLocalSinUTC(x.updatedAt) // aquí hay un detalle
        })
    }

};

